export default "__VITE_ASSET__Bsth0dKU__"